export default {
  // Player
  'wow_player_dau': '游玩-游戏活跃',
  'wow_avg_player_dau': '日平均游玩-游戏活跃',
  'wow_player_new': '游玩-游戏新进',
  'wow_avg_player_new': '日平均游玩-游戏新进',
  'wow_player_return': '游玩-游戏回流',
  'wow_avg_player_return': '日平均游玩-游戏回流',
  // Creator
  'wow_creator_dau': '创作-游戏活跃',
  'wow_avg_creator_dau': '日平均创作-游戏活跃',
  'wow_creator_new': '创作-游戏新进',
  'wow_avg_creator_new': '日平均创作-游戏新进',
  'wow_creator_return': '创作-游戏回流',
  'wow_avg_creator_return': '日平均创作-游戏回流',
};